<template>
  <div>
    <PageTitle :route="$route">
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <ModelForm v-if="model" :model="model" />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import ModelForm from '@/components/settings/stock-registers/model/ModelForm.vue'

  export default {
    name: 'Model',
    components: {
      PageTitle,
      PageRowWrapper,
      ModelForm
    },
    computed: {
      ...mapState({
        model: state => state.model.modelById
      })
    },
    methods: {
      ...mapActions('model', ['fetchById'])
    },
    mounted () {
      this.fetchById(this.$route.params.id)
    }
  }
</script>
